import { Utils } from '@/utils.js';
import { apiFetch } from '@/utils/api.js';

/*
------------------------------------------------------------------------
Call the HubSpot API to create the contact
------------------------------------------------------------------------
*/
export const createContact = async (store, force) => {
    $log.log(`[hubspot:createContact] Starting contact creation`);
    // Create/find the current HubSpot user (if we haven't already).

    if (store.user.first_name === '' || store.user.last_name === '' || store.user.company === '' || store.user.email === '') {
        $log.log(`[hubspot:createContact] Invalid data supplied. Not sending user creation request.`);
        return false;
    }

    const payload = {
        first_name: store.user.firstname,
        last_name: store.user.lastname,
        company: store.user.company,
        email: store.user.email,
        instance_id: store.instance_id,
    };

    // $log.log(`payload : ${JSON.stringify(payload, null, 4)}`);

    //
    // We only want to attempt to create a contact if we don't already have
    // a contact id in the store (which means we know the HubSpot user).
    // We can also pass in a "force" param if we want to force the call
    // to the API.
    //
    if (!store.user.user_id || force) {
        const response = await apiFetch('/wp-json/lat/v1/hubspot-create-contact', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        if (response.ok) {
            store.user.user_id = result.data.id || result.data.hs_object_id;
            store.user.company_id = result.data.company_id;
            // $log.log(`result : ${JSON.stringify(result, null, 4)}`);
            return result.data;
        } else {
            if (!force) {
                //
                // We will generally catch a failed contact creation attempt
                // as we do it every time the user progresses to a new step.
                // We also do it at report generation as a final fallback.
                // Only reason we wont catch it is if the HubSpot API is
                // down, or there is a network failure of some type.
                //
                console.error('Error creating user:', result.message);
                return false;
            }
            return false;
        }
    }
};
